<script>
import store from '@state/store'
import Layout from '@layouts/guest.vue'
import { authMethods } from '@state/helpers'
import LoginByPhone from '@guest/components/login-by-phone.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to KyndHub` }],
  },
  components: { Layout, LoginByPhone },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      tryingToLogIn: false,
    }
  },
  computed: {},
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    postPhone(params) {
      this.tryingToLogIn = true
      return this.verifyPhone({
        phonePrefix: params.prefix,
        phoneNumber: params.phone,
      })
        .then((response) => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          // this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
    skip(params) {
      this.tryingToLogIn = true
      return this.skipPhone()
        .then((response) => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'login' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
    postResend(params) {
      this.tryingToLogIn = true
      return this.resendCode()
        .then((response) => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          // this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
    redirectFunc() {
      store.dispatch('auth/validate', true).then((user) => {
        const companyId =
          user.default_company_id && user.default_company_id !== 0
            ? user.default_company_id
            : 2944
        var goToRoute = {
          name: 'company',
          params: { companyId },
        }
        if (user.phone === '' && user.skip_verify_phone !== 1) {
          goToRoute = { name: 'verify-phone' }
        }
        // Redirect to the originally requested page, or to the default company or to phone verification
        this.$router.push(this.$route.query.redirectFrom || goToRoute)
      })
    },
    postCode(params) {
      this.tryingToLogIn = true
      return this.loginByCode({
        smsCode: params.code,
      })
        .then((response) => {
          if (!response.token) {
            this.authError = 'invalid_code'
          } else {
            if (response.token) {
              this.redirectFunc()
            }
          }
        })
        .catch(() => {
          this.tryingToLogIn = false
          this.authError = 'invalid_code'
        })
    },
    clearAuthErrors() {
      this.authError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <LoginByPhone
      :auth-error="authError"
      :trying-to-login="tryingToLogIn"
      @post-phone="postPhone"
      @resend-code="resendCode"
      @verify-code="postCode"
      @clear-auth-errors="clearAuthErrors"
    ></LoginByPhone>
  </Layout>
</template>
